import mainStore from '@components/Main/store'
import {
  isWeddingCameraShootingProperty,
  isWeddingEmceeProperty,
  isWeddingMakeupProperty,
  isWeddingPhotographyProperty
} from '@merchant-backend/util'
import { observer } from 'mobx-react'
import React from 'react'
import store from '../../store'
import HotModal from './HotModal'
import styles from './style.module.less'

export default observer(() => {
  const {
    merchantInfo: { is_popular }
  } = mainStore

  const bgUrl =
    is_popular == 1
      ? '//qnm.hunliji.com/FglCDv-1u3_813aIpHINQfi4DIxD'
      : '//qnm.hunliji.com/Ft9KCctEJ9DxxNegtLViPctXhYPg'

  let merchantType = ''

  if (isWeddingEmceeProperty()) {
    merchantType = '人气主持人'
  } else if (isWeddingMakeupProperty()) {
    merchantType = '人气跟妆师'
  } else if (isWeddingPhotographyProperty()) {
    merchantType = '人气摄影师'
  } else if (isWeddingCameraShootingProperty()) {
    merchantType = '人气摄像师'
  }

  const { hotModalVisible, toggleHotModalVisible } = store

  return (
    <>
      <span
        className={styles.icon}
        style={{
          backgroundImage: `url(${bgUrl})`
        }}
        onClick={toggleHotModalVisible(true)}
      >
        {merchantType}
      </span>
      <HotModal
        visible={hotModalVisible}
        onCancel={toggleHotModalVisible(false)}
      />
    </>
  )
})
